var _rect, _path, _path2, _rect2, _rect3, _rect4, _path3, _path4, _rect5, _rect6, _rect7, _path5, _path6, _rect8, _rect9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562,
    height: 331,
    viewBox: "0 0 562 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 121,
    width: 562,
    height: 87.3519,
    rx: 4,
    fill: "#F8F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 125C0 122.791 1.80515 121 4.01429 121V208.352C1.80515 208.352 0 206.561 0 204.352V125Z",
    fill: "#E9ECEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M519.85 121H558C560.209 121 562 122.791 562 125V206C562 208.209 560.209 210 558 210H519.85V121Z",
    fill: "#F8F9FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0535,
    y: 145.722,
    width: 330.175,
    height: 13.1852,
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0535,
    y: 172.093,
    width: 76.2714,
    height: 13.1852,
    fill: "#E9ECEF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 242,
    width: 562,
    height: 87.3519,
    rx: 4,
    fill: "#F8F9FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 246C0 243.791 1.80515 242 4.01429 242V329.352C1.80515 329.352 0 327.561 0 325.352V246Z",
    fill: "#E9ECEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M519.85 242H558C560.209 242 562 243.791 562 246V327C562 329.209 560.209 331 558 331H519.85V242Z",
    fill: "#F8F9FA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0535,
    y: 266.722,
    width: 330.175,
    height: 13.1852,
    fill: "#E9ECEF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0535,
    y: 293.093,
    width: 76.2714,
    height: 13.1852,
    fill: "#E9ECEF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 562,
    height: 87.3519,
    rx: 4,
    fill: "#F8F9FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79087 1.80515 0 4.01429 0V87.3519C1.80515 87.3519 0 85.561 0 83.3519V4Z",
    fill: "#E9ECEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M519.85 0H558C560.209 0 562 1.79086 562 4V85C562 87.2091 560.209 89 558 89H519.85V0Z",
    fill: "#F8F9FA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0535,
    y: 24.7222,
    width: 330.175,
    height: 13.1852,
    fill: "#E9ECEF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0535,
    y: 51.0925,
    width: 76.2714,
    height: 13.1852,
    fill: "#E9ECEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCard);
export default __webpack_public_path__ + "static/media/no_card.f018666c542a6fb2e6b601d569f3e757.svg";
export { ForwardRef as ReactComponent };